export default function getSubmitData(values, cookie) {
  // get the fields to submit
  let fields = [];

  Object.keys(values).forEach((field) => {
    fields = [
      ...fields,
      {
        name: field,
        value: values[field],
      },
    ];
  });

  return {
    submittedAt: Math.floor(Date.UTC() / 1000),
    fields,
    context: {
      hutk: cookie,
      pageUri: 'oacct.aibes.org',
      pageName: 'Official Agile Coach Training',
    },
  };
}
